<template>
    <VAppLayout>
        <VContainer>
            <CartTab :orderId="orderId"
                     @show-regulamin="showRegulamin" />
        </VContainer>

        <VBottomSheet v-if="showSmRegulamin"
                      v-model="regulaminOpen"
                      :title="$t('pages.cart.regulaminCheckboxTitle2')">
            <div class="regulamin-sheet-content" v-html="sm_terms"></div>
        </VBottomSheet>
    </VAppLayout>
</template>

<script>

import VAppLayout from "@/layouts/VAppLayout.vue";
import VContainer from "@/components/ui/VContainer.vue";
import VBottomSheet from "@/components/ui/VBottomSheet.vue";
import loader from "@/plugins/loader.plugin";
import CartTab from "./components/CartTab.vue";

export default {
    name: "Cart",
    props: ['orderId'],
    components: {
        VContainer,
        VAppLayout,
        VBottomSheet,
        CartTab,
    },
    data() {
        return {
            loading: false,
            regulaminOpen: false,
            sm_terms: this.$store.getters['getCompanyData'].locale.sm_terms,
            sm_show_terms: this.$store.getters['getCompanyData'].locale.sm_show_terms,
        };
    },
    computed: {
        showSmRegulamin() {
            return (this.sm_show_terms && this.sm_terms && this.sm_terms.length > 0);
        },
        isWMM() {
            return this.$store.getters['getIsModeWMM'];
        }
    },
    methods: {
        showRegulamin() {
            this.regulaminOpen = true;
        },
        showLoader() {
            this.loading = true;
            loader.show();
        },
        hideLoader() {
            this.loading = false;
            loader.hide();
        },
    }
};
</script>

<style lang="scss" scoped>
.regulamin-sheet-content {
    white-space: pre-line;
    font-size: var(--text-base);
    line-height: var(--leading-relaxed);
    color: var(--text-secondary);

    ::v-deep a {
        color: var(--color-primary);
        text-decoration: underline;
    }

    ::v-deep strong,
    ::v-deep b {
        color: var(--text-primary);
        font-weight: var(--weight-bold);
    }
}
</style>
